import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import { ContractListItem } from "../../dtos/contracts";
import { PROPERTY_TRACKS } from "../../utils";

export const downloadGeneratedContract = async ({
  contractUid,
}: {
  contractUid: string;
}) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONTRACTS_API_URL}/contracts/${contractUid}/download-generated-contract`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      responseType: "json",
    },
  }) as Promise<{
    data: { url: string };
    headers: Record<string, string>;
  }>;
};

export const getPropertyContractsForDocumentsTab = async (data: {
  propertyUid: string;
  type?: PROPERTY_TRACKS;
}) => {
  const queryParams = data.type ? `?type=${data.type}` : "";
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONTRACTS_API_URL}/properties/${data.propertyUid}/contracts/documents-list${queryParams}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<{
    data: ContractListItem[];
  }>;
};
